<template lang="pug">
    .settings(v-if='settings')
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') }}:
            | {{ $i18n.t(typeLabel) }}
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
        div
            | {{ $i18n.t('trainer.trainer_gamePlayBox_amount') + " " +  $i18n.t(amountLabel) }}:
            | {{ settings.itemsAmount }}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_blackWhiteImages') }}:
            | {{ settings.blackWhiteImages ? $i18n.t('trainer.trainer_gameFormSettingValue_on') : $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
        div(v-if="settings.complication")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}:
            | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        slot
</template>

<script>
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import getBase64FromUrl from '../../../utils/getBase64FromUrl';

    export default {
        mixins: [gamePreviewMixin, getBase64FromUrl],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
        computed: {
            amountLabel() {
                return +this.settings.itemsType.value === 2
                    ? 'trainer.trainer_gamePlayBox_couples'
                    : 'trainer.trainer_gamePlayBox_triads';
            },
            typeLabel() {
                return +this.settings.itemsType.value === 2
                    ? 'trainer.trainer_items_type_couples'
                    : 'trainer.trainer_items_type_triads';
            },
        },
        components: {
            GamesList: () => ({
                component: new Promise(resolve => require(['../GamesList.vue'], resolve)),
            }),
        },
    };
</script>

<style lang="scss" scoped>
    .image-preview {
        width: 200px;
    }
</style>
